module.exports = __webpack_public_path__ + "assets/0b9d24f00739fa2fe70d395debc22a8f.png";